import React from 'react';
import PropTypes from 'prop-types';

import { map } from 'lodash-es';

import FieldBirthDate from '../../Common/Fields/FieldBirthDate';
import FieldDate from '../../Common/Fields/FieldDate';
import FieldInput from '../../Common/Fields/FieldInput';
import FieldInputNumber from '../../Common/Fields/FieldInputNumber';
import FieldInputPercent from '../../Common/Fields/FieldInputPercent';
import FieldRadioGroup from '../../Common/Fields/FieldRadioGroup';
import FieldSelect from '../../Common/Fields/FieldSelect';
import FieldInputPhone from '../../Common/Fields/FieldInputPhone';
import FieldSelectCountry from '../../Common/Fields/FieldSelectCountry';
import FieldInputSsn from '../../Common/Fields/FieldInputSsn';
import FieldCalculated from '../../Common/Fields/FieldCalculated';

import { WebInputField } from '../QuestionnaireBlock.enum';
import { TypesFieldEnum } from '../../../Utils/enum';

/**
 * handle fields
 * @param {*} param0
 */
const HandleFields = ({
  code,
  selection,
  digits,
  type,
  disabled,
  webInput,
  validate,
  existError,
  showError,
  setValueQuestion,
  blockId,
  param,
  placeholder,
  thousandSeparator,
  decimalSeparator,
  componentCommon,
}) => {
  switch (type) {
    case TypesFieldEnum.DATE:
      return (
        <FieldDate
          code={code}
          disabled={disabled}
          existError={existError}
          showError={showError}
          validate={validate}
          handleBlur={setValueQuestion}
          param={param}
        />
      );
    case TypesFieldEnum.BIRTH_DATE:
      return (
        <FieldBirthDate
          code={code}
          disabled={disabled}
          existError={existError}
          showError={showError}
          validate={validate}
          handleBlur={setValueQuestion}
          param={param}
        />
      );
    case TypesFieldEnum.PHONE:
      return (
        <FieldInputPhone
          code={code}
          disabled={disabled}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={setValueQuestion}
        />
      );
    case TypesFieldEnum.SELECTIONCOUNTRY: {
      return (
        <FieldSelectCountry
          code={code}
          disabled={disabled}
          validate={validate}
          existError={existError}
          showError={showError}
          handleChange={setValueQuestion}
        />
      );
    }
    case TypesFieldEnum.SSN:
      return (
        <FieldInputSsn
          code={code}
          disabled={disabled}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={setValueQuestion}
        />
      );
    case TypesFieldEnum.NUMERIC:
      return (
        <FieldInputNumber
          code={code}
          disabled={disabled}
          decimalScale={digits}
          thousandSeparator={thousandSeparator}
          decimalSeparator={decimalSeparator}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={setValueQuestion}
          param={param}
          placeholder={placeholder}
        />
      );
    case TypesFieldEnum.CURRENCY:
      return (
        <FieldInputNumber
          code={code}
          disabled={disabled}
          decimalScale={digits}
          thousandSeparator={thousandSeparator}
          decimalSeparator={decimalSeparator}
          suffix="€"
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={setValueQuestion}
          param={param}
          placeholder={placeholder}
        />
      );
    case TypesFieldEnum.PERCENTAGE:
      return (
        <FieldInputPercent
          code={code}
          disabled={disabled}
          decimalScale={digits}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={setValueQuestion}
          thousandSeparator={thousandSeparator}
          decimalSeparator={decimalSeparator}
        />
      );
    // SELECTION
    case TypesFieldEnum.SELECTION: {
      switch (webInput) {
        case WebInputField.CHECKBOX: {
          return (
            <FieldRadioGroup
              code={code}
              disabled={disabled}
              selection={selection}
              validate={validate}
              existError={existError}
              showError={showError}
              handleChange={setValueQuestion}
              blockId={blockId}
            />
          );
        }
        default: {
          return (
            <FieldSelect
              code={code}
              disabled={disabled}
              // value={value}
              selection={selection}
              validate={validate}
              existError={existError}
              showError={showError}
              handleChange={setValueQuestion}
            />
          );
        }
      }
    }
    // MULTISELECTION
    case TypesFieldEnum.MULTISELECTION: {
      switch (webInput) {
        case WebInputField.CHECKBOX: {
          return (
            <FieldRadioGroup
              code={code}
              disabled={disabled}
              selection={selection}
              validate={validate}
              existError={existError}
              showError={showError}
              handleChange={setValueQuestion}
              blockId={blockId}
            />
          );
        }
        default: {
          return (
            <FieldSelect
              code={code}
              disabled={disabled}
              selection={selection}
              validate={validate}
              existError={existError}
              showError={showError}
              handleChange={setValueQuestion}
              isMulti
            />
          );
        }
      }
    }
    case TypesFieldEnum.CALCULATED:
      return (
        <FieldCalculated
          componentCommon={componentCommon}
          code={code}
          disabled={disabled}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={setValueQuestion}
          placeholder={placeholder}
          param={{ ...param, thousandSeparator, decimalSeparator, selection }}
        />
      );
    case TypesFieldEnum.TEXT:
    case TypesFieldEnum.EMAIL:
    default:
      return (
        <FieldInput
          code={code}
          disabled={disabled}
          type="text"
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={setValueQuestion}
          placeholder={placeholder}
        />
      );
  }
};

HandleFields.propTypes = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  digits: PropTypes.number,
  selection: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  type: PropTypes.oneOf(map(TypesFieldEnum, item => item)).isRequired,
  disabled: PropTypes.bool,
  webInput: PropTypes.oneOf(map(WebInputField, item => item)),
  validate: PropTypes.func.isRequired,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  setValueQuestion: PropTypes.func.isRequired,
  blockId: PropTypes.string,
  param: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string,
  }),
  placeholder: PropTypes.string,
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
  componentCommon: PropTypes.string,
};

HandleFields.defaultProps = {
  digits: undefined,
  selection: undefined,
  webInput: undefined,
  disabled: false,
  blockId: '',
  param: {},
  placeholder: undefined,
  thousandSeparator: undefined,
  decimalSeparator: undefined,
  componentCommon: undefined,
};

export default HandleFields;
